module.exports = __webpack_public_path__ + "static/img/food-policy03.8ddfd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy03.png
// module id = ORBT
// module chunks = 1